import { Component, EventEmitter, Inject, Input, Output, OnInit, OnChanges, SimpleChanges, SimpleChange } from 'ng-metadata/core';
import * as momentTz from 'moment-timezone';
import '../date-picker.scss';
import './date-picker-dropdown.scss';


/**
 * @ngdoc directive
 * @name mwDatePickerDropdown
 * @module mw.components.datePicker
 *
 * @param {Date} [date] - 'The date that was picker is listening on'
 * @param {string} [locale] - 'The language that the date picker will be shown in'
 * @param {string} [min-view] - 'The starting view of when the user opens up the date picker'
 * @param {string} [max-view] - 'How deep the user can go into the calendar all the way to seconds'
 * @param {string} [start-view] - 'View in which the calendar starts at'
 * @param {string} [format] - 'The format of how the date will be presented'
 * @param {string} [label] - 'The label of the input'
 * @param {Date} [min-date] - 'The minimum date that the user can go down to'
 * @param {Date} [max-date] - 'The maximum date that the user can go up to'
 * @param {EventEmitter} [on-date-selection] - 'What to do when the date is selected'
 * @param {string} [form-input-name] - 'The name of the input if its in a form'
 * @param {boolean} [is-required] - 'Determines whether or not the input is required'
 * @param {boolean} [is-today-highlighted] - 'Control if today is highlighted or not'
 * @param {boolean} [disabled] - 'Determines whether the input is disabled or not'
 * @param {string} [timezone] - Timezone to be used by date picker. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 *
 * @usage
 * <hljs hljs-language="html">
 *  <mw-date-picker-dropdown
 *      date=""
 *      locale="en"
 *      min-view="month"
 *      max-view="month"
 *      start-view="month"
 *      format="L LTS"
 *      on-date-selection="$ctrl.handleDateChange($event)"
 * > </mw-date-picker-dropdown>
 * </hljs>
 */
@Component({
    selector: `mw-date-picker-dropdown`,
    template: `

    <input
        ng-required="$ctrl.isRequired"
        name="{{$ctrl.formInputName}}"
        moment-picker="$ctrl.selectedFormattedDate"
        ng-model="$ctrl.selectedMoment"
        value="{{$ctrl.date}}"
        ng-disabled="$ctrl.disabled"
        class="mw-date-picker mw-date-picker-dropdown"
        format="{{$ctrl.format}}"
        locale="{{$ctrl.locale}}"
        min-view="{{$ctrl.minView}}"
        max-view="{{$ctrl.maxView}}"
        start-view="{{$ctrl.startView}}"
        timezone="$ctrl.timezone"
        today="$ctrl.isTodayHighlighted"
        change="$ctrl.handleDateChange(newValue, oldValue)"
        min-date="$ctrl.minDate"
        max-date="$ctrl.maxDate"
    >
    <button
        class="mw-datepicker-dropdown__triangle-button md-icon-button md-button"
        ng-click="$ctrl.openDatePicker($event)"
        md-ink-ripple
    >
        <div class="mw-datepicker-dropdown__triangle ng-scope"> </div>
    </button>
    `
})

export class DatePickerDropdownComponent implements OnInit, OnChanges {
    @Input('<') locale: string = 'en';
    @Input('<') date: any;
    @Input('<') minView: string;
    @Input('<') maxView: string;
    @Input('<') startView: string;
    @Input('<') format: string = 'L LTS';
    @Input('<') label: string;
    @Input('<') formInputName: string;
    @Input('<') isRequired: boolean;
    @Input('<') isTodayHighlighted: boolean;
    @Input('<') timezone: string = '';
    @Input('<') minDate: any;
    @Input('<') maxDate: any;
    @Input('<') disabled: boolean = false;
    @Output() onDateSelection = new EventEmitter();

    isOpened: boolean = false;
    selectedMoment;
    selectedFormattedDate: string;

    constructor(@Inject('$element') private $element: ng.IRootElementService) {
        this.$element.find('input')[0].addEventListener('keydown', (e) => {
            e.preventDefault();
        });

        this.startView = this.startView ? this.startView : 'month';
    }

    ngOnInit() {
        this.isTodayHighlighted = this.isTodayHighlighted ? this.isTodayHighlighted : false;
        this.timezone = this.timezone ? this.timezone : momentTz.tz.guess(); // If no timezone is passed in, let moment guess the timezone
        this.selectedMoment = this.date ? momentTz(this.date).tz(this.timezone) : null;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['date'] && !changes['date'].isFirstChange()) {
            this.selectedMoment = changes.date.currentValue ? momentTz(changes.date.currentValue).tz(this.timezone) : null;
        }
    }

    openDatePicker(event) {
        this.$element.find('input')[0].focus();
        this.isOpened = true;
    }

    handleDateChange(newValue, oldValue) {
        let now = momentTz().tz(this.timezone);
        this.selectedMoment = momentTz(newValue).tz(this.timezone);

let eventData = {date: newValue,  moment: this.selectedMoment};
       this.onDateSelection.emit(eventData)
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-picker/dropdown/date-picker-dropdown.component.ts